import React from "react";
import { Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "../Utils/utils";
import {
  monerisPayment,
  cloverPayment,
  registerOrder,
} from "../apis/RangerOnlineApi";
import { useNavigate } from "react-router-dom";
import { AlertPopUp } from "./AlertPopUp";
const CardInfoType = {
  cardNumber: "",
  nameOnCard: "",
  expiryDate: "",
  cardCVC: "",
  amount: 0,
};

export const GenericPaymentForm = (props) => {
  const { order, paymentProvider } = props;
  const [cardInfo, setCardInfo] = useState({ ...CardInfoType });
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  let navigate = useNavigate();

  const handleInputChange = ({ target }) => {
    let copyCardInfo = { ...cardInfo };
    if (target.name === "cardNumber") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiryDate") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cardCVC") {
      target.value = formatCVC(target.value);
    }
    copyCardInfo[target.name] = target.value;
    setCardInfo(copyCardInfo);
  };

  const handlePayment = async () => {
    let cardInfoCopy = { ...cardInfo };
    cardInfoCopy.amount = order.orderTotal;
    const response =
      paymentProvider === "moneris"
        ? await monerisPayment(cardInfoCopy)
        : await cloverPayment({
            ...cardInfoCopy,
            cardNumber: cardInfoCopy.cardNumber.replaceAll(" ", ""),
          });

    if (response && response?.status === "succeeded") {
      let finalOrder = { ...order };

      finalOrder.notes = "";
      const orderResponse = await registerOrder({
        ...finalOrder,
        paymentType: "card",
      });

      if (orderResponse && orderResponse?.responseCode === "0000") {
        navigate(`/Success/${orderResponse.orderId}`);
      }
    } else {
      setShowAlert(true);
      setMessage("Payment not succeeded.Try Again");
    }
  };

  return (
    <>
      <Grid container rowGap={1}>
        <Grid item xs={12}>
          <TextField
            required
            type="text"
            id="nameOnCard"
            name="nameOnCard"
            label="Name on card"
            fullWidth
            inputProps={{ pattern: "[a-z A-Z-]+" }}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            type="tel"
            id="cardNumber"
            name="cardNumber"
            label="Card number"
            fullWidth
            inputProps={{ pattern: "[d| ]{16,22}", maxLength: "19" }}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            type="tel"
            id="expiryDate"
            name="expiryDate"
            label="Expiry date"
            inputProps={{ pattern: "dd/dd" }}
            fullWidth
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            type="tel"
            id="cardCVC"
            name="cardCVC"
            label="CVV"
            inputProps={{ pattern: "d{3}" }}
            helperText="Last three digits on signature strip"
            fullWidth
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
      <Button variant="contained" onClick={handlePayment}>
        Pay
      </Button>
      {showAlert ? (
        <AlertPopUp
          show={showAlert}
          message={message}
          onClose={() => setShowAlert(false)}
          closeOnTimer={false}
        />
      ) : null}
    </>
  );
};
